import { render, staticRenderFns } from "./cpt-dataV-digitalFlop-option.vue?vue&type=template&id=0586114e&scoped=true"
import script from "./cpt-dataV-digitalFlop-option.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-digitalFlop-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0586114e",
  null
  
)

export default component.exports